import React from 'react'
import { Link } from 'react-router-dom'
import { MoreContentArrow } from './MoreContentArrow'

const SocialLinks = () => (
  <ul>
    <li>
      <a href="https://www.facebook.com/edulgal.co" target="_blank" rel="noopener noreferrer">
        <i className="icon-fb" />
      </a>
    </li>
    <li>
      <a href="https://www.linkedin.com/company/edulegal-co" target="_blank" rel="noopener noreferrer">
        <i className="icon-lin" />
      </a>
    </li>
  </ul>
)

const WithoutLink = () => (
  <div className="footer-container">
    <SocialLinks />
  </div>
)

export const WithLink = () => (
  <div className="footer-container with-border">
    <div className="link-to-contact-container text">
      <span>"¿Quiere programar una cita?"</span>
    </div>

    <div className="link-to-contact-container">
      <Link to="/contacto">Contacto</Link>
    </div>

    <SocialLinks />
  </div>
)

export const Footer = ({ withLinkToContact = false }) => (
  <div className="footer">
    <MoreContentArrow />
    {withLinkToContact ? <WithLink /> : <WithoutLink />}
  </div>
)
